module.exports = __webpack_public_path__ + "static/assets/2022aacc9b4aa00f6bfbf9e5d50708b3.png";